import { useState } from "react";
import { useCookies } from 'react-cookie';

export const useAlaskaForBusiness = () => {
    const [cookies] = useCookies(['AFB']);
    const [isBusiness] = useState(cookies.AFB === "True");
    return isBusiness;
};